import log from './log'
import { customLog } from './log2'
import md5 from 'crypto-js/md5'

// 检测是否为社媒登录返回
export const checkCallback = () => {
  const search = window.location.search || window.newLocation.search
  const hash = window.location.hash || window.newLocation.hash
  let params
  if (search) {
    params = parseParams(search)
    // google code 授权
    if (params.state && params.code) {
      return params
    }
  } else if (hash) {
    params = parseParams(hash)
    // google token 授权
    if (params.access_token) {
      return params
    }
  }
  return false
}

export const parseParams = str => {
  const query = str.substring(1)
  const vars = query ? query.split('&') : []
  const params = {}
  vars.forEach(item => {
    const pair = item.split('=')
    params[pair[0]] = decodeURIComponent(pair[1])
  })
  return params
}

export const getParamsFromUrl = (flag) => {
  const oldParams = JSON.parse(window.localStorage.getItem('sdkParams') || '{}')
  if (['/result', '/verify'].indexOf(window.location.pathname) > -1 && JSON.stringify(oldParams) !== '{}') return oldParams
  let search = ''
  if (flag) {
    search = window.newLocation.search
  } else {
    search = window.location.search || window.getLocationSearch()
  }
  const query = search.substring(1)
  const vars = query ? query.split('&') : []
  const params = {}
  vars.forEach(item => {
    const pair = item.split('=')
    params[pair[0]] = pair[1]
    if (pair[0] === 'lang') {
      params[pair[0]] = pair[1].replace('_', '-')
      const lang = pair[1].split('-')
      lang[1] && (lang[1] = lang[1].toUpperCase())
      params.webLang = lang.join('_')
    }
  })
  if (['/'].indexOf(window.location.pathname) > -1 && checkCallback()) {
    params.source_id = 1
  }
  if (JSON.stringify(params) === '{}') {
    if (JSON.stringify(oldParams) !== '{}') {
      return oldParams
    }
  }
  if (!params.track_key) {
    params.track_key = randomString()
  }
  params.logData = JSON.parse(decodeURIComponent(params.logData || '') || '{"basic":{},"properties":{}}')
  params.bindinfo = JSON.parse(decodeURIComponent(params.bindinfo || '') || '{}')
  // game id, 默认是 ss
  params.gid = params.gid || '30001'
  if (typeof window.qt !== 'undefined') {
    params.source_id = 2
  } else {
    params.source_id = Number(params.source_id ?? 1)
  }
  return params
}

export const randomString = l => {
  l = l || 32
  var t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  var a = t.length
  var n = ''
  for (var i = 0; i < l; i++) n += t.charAt(Math.floor(Math.random() * a))
  return n
}

export const isEmail = s => {
  const rep = /^(\w|([.\w-]+))+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,5}$/
  return rep.test(s)
}

export const getAction = () => {
  const params = JSON.parse(window.localStorage.getItem('sdkParams'))
  return params.action
}

export const getTS = () => new Date().getTime()

export const bindEvent = (el, ename, fn, cap) => {
  cap = cap || false
  el.addEventListener(ename, fn, cap)
}

export const unBindEvent = (el, ename, fn, cap) => {
  cap = cap || false
  el.removeEventListener(ename, fn, cap)
}

export const getUuid = () => {
  if (typeof crypto === 'object') {
    if (typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID()
    }
    if (typeof crypto.getRandomValues === 'function' && typeof Uint8Array === 'function') {
      const callback = (c) => {
        const num = Number(c)
        return (num ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (num / 4)))).toString(16)
      }
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, callback)
    }
  }
  let timestamp = new Date().getTime()
  let perforNow = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let random = Math.random() * 16
    if (timestamp > 0) {
      random = (timestamp + random) % 16 | 0
      timestamp = Math.floor(timestamp / 16)
    } else {
      random = (perforNow + random) % 16 | 0
      perforNow = Math.floor(perforNow / 16)
    }
    return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16)
  })
}

export const string10to62 = (number) => {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(''),
    radix = chars.length,
    qutient = +number,
    arr = []
  do {
    var mod = qutient % radix
    qutient = (qutient - mod) / radix
    arr.unshift(chars[mod])
  } while (qutient)
  return arr.join('')
}

export const isQt = (() => typeof window.qt !== 'undefined')()

export const utf8ToB64 = str => {
  return window.btoa(unescape(encodeURIComponent(str)));
}

export const b64ToUtf8 = str => {
  return decodeURIComponent(escape(window.atob(str)));
}

// Date polyfill
Date.prototype.getUTCTime = function () {
  return new Date(
    this.getUTCFullYear(),
    this.getUTCMonth(),
    this.getUTCDate(),
    this.getUTCHours(),
    this.getUTCMinutes(),
    this.getUTCSeconds()
  ).getTime()
}

export const isPC = (() => {  
  const userAgentInfo = navigator.userAgent
  const Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod')
  let flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
})()

// 当前版本大于指定版本
export const gtVersion = version => {
  const crtV = Number(JSON.parse(window.localStorage.getItem('sdkParams') || '{}').version || 0)
  return crtV >= version
}

export const getGame = () => {
  const gid = JSON.parse(window.localStorage.getItem('sdkParams') || '{}').gid
  const gameMap = {
    30001: 'ss',
    2031: 'koa',
    2064: 'gog',
    2200: 'mc_global',
    2202: 'st_global',
    100013: 'antia',
    60004: 'entropy'
  }
  return gameMap[gid] || ''
}

/**
 * 社媒登录 state 参数
 * @param {*} params 
 * @returns 
 */
const stateArrConf = ['platform', 'oauthtype', 'gid', 'game_project', 'lang', 'passportSDK']
export const getSocialOauthState = (params) => {
  const stateArr = stateArrConf.map(item => params[item])
  return stateArr.join('__')
}
export const parseSocialOauthState = (state) => {
  if (!state) return {}
  const arr = state.split('__')
  const o = {}
  stateArrConf.forEach((item, i) => {
    o[item] = arr[i]
  });
  return o
}

export function md5Hash (str) {
  return md5(str).toString();
}

export default {
  getAction,
  parseParams,
  getParamsFromUrl,
  randomString,
  isEmail,
  bindEvent,
  log,
  getUuid,
  string10to62,
  getTS,
  isQt,
  isPC,
  gtVersion,
  getGame,
  customLog,
  utf8ToB64,
  b64ToUtf8,
  checkCallback,
  getSocialOauthState,
  parseSocialOauthState,
  md5Hash,
}
